var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icons"},[_c('h1',[_vm._v("Lorem ipsum dolor amet, consectetur ?")]),_c('div',{staticClass:"items"},[_c('iconItem')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }